import { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import type { DiaChiNhanHang, DiaChiNhanHangInput, KhoHang } from '@/types/schemas';
import { formSchema, FormValues, initialValues } from '../schemas';
import { FormMode } from '@/types/form';
import Form from './BasicForm';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;

  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;
  onSubmit: (data: DiaChiNhanHangInput) => void;
  initialData?: DiaChiNhanHang | null;
}
function FormDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  onSubmit,
  initialData
}: FormDialogProps) {
  const [kho, setKho] = useState<KhoHang | null>(initialData?.ma_kho_data || null);
  const handleSubmit = async (data: FormValues) => {
    try {
      await onSubmit({
        ...data,
        ma_kho: kho?.uuid || null
      } as DiaChiNhanHangInput);
    } catch (err: unknown) {
      () => {};
    }
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={(initialData as Partial<FormValues> | null | undefined) || initialValues}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<Form mode={mode} kho={kho} setKho={setKho} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default FormDialog;
